export enum PartnerManagedAccountStatus {
  Active = "active",
  Revoked = "revoked",
}
